import Vue from 'vue';

window.axios = require('axios');

import SocialSharing from 'vue-social-sharing';
Vue.use(SocialSharing);

import locale from 'element-ui/lib/locale/lang/en';
import ElementUI from 'element-ui';
Vue.use(ElementUI, { locale });

window._ = require('lodash');
window.Numeral = require('numeral');
window.ScrollMagic = require('scrollmagic');

require('promise/polyfill-done');
